// @ts-check

/**
 * Escapes a value for interpolation into admin dashboard HTML strings.
 *
 * @param {unknown} str
 * @returns {string}
 */
export function escapeHtml(str) {
  if (!str) return '';
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
}

/**
 * Wraps row action buttons so mobile stacked cards keep them inline instead of
 * stretching each control to the full card width.
 *
 * @param {string} innerHtml
 * @returns {string}
 */
export function tableActionsHtml(innerHtml) {
  return '<div class="table-row-actions">' + String(innerHtml || '') + '</div>';
}
